import React from "react";
import { ShadowForCurves } from "../styles/shared";
import { graphql } from "gatsby";
import { DeepNonNullable } from "ts-essentials";
import { GatsbyImage } from "gatsby-plugin-image";
import { HubSpotBookingLink } from "./HubSpotBookingLink";

type CommonProps = {
  authorId: string | number;
  withAuthorName?: boolean;
  data: DeepNonNullable<Queries.BookDemoDataQuery>;
  sliceContext: { locale: string };
};

const BookDemoBig = ({
  data,
  authorId,
  withAuthorName = false,
}: CommonProps) => {
  const {
    allStrapiBookDemo: { nodes },
    strapiBookDemo: defaultBookDemo,
  } = data;

  const dataBookDemo = authorId
    ? nodes.filter(item => item.id === authorId)[0]
    : defaultBookDemo;

  return (
    <div
      className="relative flex w-min flex-col rounded-3xl bg-white p-1 md:flex-row"
      style={{
        ...ShadowForCurves,
        maxWidth: "800px",
      }}
    >
      {withAuthorName && (
        <div className="absolute left-[20px] bottom-[20px] z-10 hidden bg-black pl-1 pr-1 md:block">
          <p className="m-0 text-lg text-white">
            {dataBookDemo.author.AuthorName}
          </p>
          <p className="m-0 font-light text-gray-200">
            {dataBookDemo.author.AuthorJobTitle}
          </p>
        </div>
      )}
      <div className="w-72 basis-[110%] overflow-hidden rounded-3xl md:w-[400px]">
        <GatsbyImage
          key={dataBookDemo.author.AuthorImage.id}
          image={
            dataBookDemo.author.AuthorImage.localFile.childImageSharp
              .gatsbyImageData
          }
          alt={dataBookDemo.author.AuthorImage.alternativeText || ""}
          className="overflow-hidden rounded-3xl bg-gradient-to-r from-accuRankerPurple-900 to-[#070e36]"
          objectFit="contain"
        />
      </div>
      <div className="l:flex-[1_0_60%] md:-ml-20 md:flex md:flex-row md:justify-around">
        <div className="relative left-[47px] z-0 mt-[40%] inline-table hidden h-[40px] w-[40px] rotate-45 rounded bg-white md:block" />
        <div className="z-10 m-0 flex basis-72 flex-col items-center justify-between rounded-3xl bg-white p-5 py-8 md:w-9/12 md:rounded-r-3xl md:rounded-l-none">
          <p className="mb-6 w-full text-lg font-normal text-accuRankerPurple-500">
            {dataBookDemo.text}
          </p>
          <HubSpotBookingLink
            buttonText={dataBookDemo.callToAction}
            hubSpotBookingUrl={dataBookDemo.author.BookingUrl}
            analyticsId="schedule_meeting_button"
            className="w-full text-sm"
            onClick={() => {
              window.gtag?.("event", "book_demo_step_1");
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default BookDemoBig;

export const query = graphql`
  query BookDemoData($locale: String, $defaultAuthor: String) {
    allStrapiBookDemo(filter: { locale: { eq: $locale } }) {
      nodes {
        id
        callToAction
        text
        author {
          AuthorName
          AuthorJobTitle
          BookingUrl
          AuthorImage {
            id
            alternativeText
            localFile {
              childImageSharp {
                gatsbyImageData(width: 400)
              }
            }
          }
        }
      }
    }
    strapiBookDemo(
      locale: { eq: $locale }
      author: { email: { eq: $defaultAuthor } }
    ) {
      id
      callToAction
      text
      author {
        AuthorName
        AuthorJobTitle
        BookingUrl
        AuthorImage {
          id
          alternativeText
          localFile {
            childImageSharp {
              gatsbyImageData(width: 400)
            }
          }
        }
      }
    }
  }
`;
